<template>
  <div>
    <v-layout row v-if="error">
      <v-flex xs12 sm8 offset-sm2>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <h3 class="headline mb-3">Email verification sent</h3>
        <p>We've sent an email with a verification code. Please confirm the code below:</p>
        <p>{{ accountId }}</p>
        <v-card light class="mb-5">
          <v-card-text>
            <!-- <v-container> -->
              <v-form 
                @submit.prevent="onSubmit"
                v-model="valid"
                ref="form"
                lazy-validation                
              >
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="code"
                      label="Verification code"
                      id="code"
                      v-model="code"
                      type="text"
                      :rules="[rules.required]"
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>               
                <v-layout row align-top>
                  <v-flex xs6 class="text-xs-left">
                    <v-btn
                      @click="goBack"
                      class="ml-0"
                      outline
                      color="secondary"
                    >&laquo; Back</v-btn>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <v-btn outline primary type="submit" :loading="loading" :disabled="loading === true || valid === false" class="mr-0">
                      Send
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            <!-- </v-container> -->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { HTTP } from '@/http-common'
  export default {
    props: {
      accountId: {
        required: true
      },
      user: {
        require: true,
        type: Object
      }
    },
    data () {
      return {
        valid: true,
        loading: false,
        code: null,
        rules: {
          required: (v) => {
            return !!v || 'Required'
          }
        }
      }
    },
    computed: {
      error () {
        return this.$store.getters.error
      }
    },
    watch: {
      error (val) {
        console.log('got an error: ', val)
        if (!val) { return }

        var status = val.response.status
        console.log('status: ', status)
        // switch (status) {
        //   case 403:
        //     this.alertMessage = `An account with that email already exists. You can <a href="${this.$router.resolve({ name: 'forgot-password' }).href}">reset your password</a> if you've forgotten it.`
        //     break

        //   case 500:
        //   default:
        //     this.alertMessage = 'Oops, Something went wrong. Please try again later.'
        //     break
        // }
      }
    },
    methods: {
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/')
      },
      onSubmit () {
        if (this.$refs.form.validate()) {
          this.loading = true

          HTTP.post('/verify-email', {
            code: this.code,
            contact: this.user
          })
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.$router.push({ name: 'reset-email-sent' })
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
          })
        } else {
          console.log('invalid...')
        }
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      }
    }
  }
</script>

<style scoped>
  .expired-link {
    color: #E53935;
    font-weight: light;
  }
</style>


// WEBPACK FOOTER //
// src/components/user/VerifyEmail.vue